export const BASEURL = "http://216.219.84.38:8585/";
export const IMAGEBASEURL = "";
export const APIBASEURL = "http://216.219.84.38:8686/";
export const FILESERVERURL = "http://216.219.84.38:6969/CLOUD_POS/";
export const SERVERIP = "http://216.219.84.38";
